import { memo, useContext } from "react"
import { DTO_MobileProfile } from "../../../../../../services/calls/types/mobiles"
import { MOBILE_PROFILE_MAP, MobileInfo } from "./data"
import InfoDisplay from "../../../../../../components/InfoDisplay"

import './index.scss'
import { DateTime } from "luxon"
import { useTranslation } from "react-i18next"
import Button from "../../../../../../components/Button"
import Icon from "../../../../../../components/Icon"
import { ICON } from "../../../../../../components/Icon/data"
import { COLOR } from "../../../../../../data/variables"
import { useNavigate } from "react-router-dom"
import { stringifyParams } from "../../../../../../services/utils/api"
import UserContext from "../../../../../../contexts/UserContext/context"

type MobileProfile = {
  data: DTO_MobileProfile
}

const MobileProfile = memo(({ data }: MobileProfile) => {
  const { user } = useContext(UserContext)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const formatFunction = (value: any, mapInfo: MobileInfo) => {
    if (!value) return ''

    if (mapInfo.id === 'milage') {
      return `${Math.round(value).toLocaleString()} km`
    } else if (mapInfo.id === 'insurance_status') {
      return value ? t('Insured') : t('Not insured')
    } else if (mapInfo.type === 'date') {
      return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
    } else if (mapInfo.type === 'temp') {
      const time = DateTime.fromISO(value?.datadate).toLocaleString(DateTime.DATETIME_MED)
      const temperature = parseFloat(value?.temperature).toFixed(1)
      return `${temperature}˚C ${time}`
    }

    return value
  }
  
  return (
    <div className="MobileProfile">
      {Object.values(MOBILE_PROFILE_MAP).map((val) => {
        const isVisible = typeof val?.visible !== 'undefined' ? val.visible(data) : true
        if (!isVisible) return null
        const infoArr = val?.data.filter((d) => typeof d.visible !== 'undefined' ? d.visible(user?.permissions) : true).map((d) => {
          const { path, source, label, index, type, id } = d
          let value = data[path] ?? null
          if (source === 'automobile') value = data.automobile[path]
          if (source === 'all_fleets') value = data.all_fleets.map((v) => v[path])
          if (source === 'sensor') value = data.sensor[index ?? 0]?.[path]
          
          value = formatFunction(value, d)
          if (type === 'img') return { label: t(label), value, type }
          else if (id === 'todays_history') {
            const buttonLabel = <>{t(label)}<Icon icon={ICON.LAUNCH} color={COLOR.WHITE} fill={COLOR.WHITE} /></>
            const today = DateTime.now().toUTC()
            const params = stringifyParams({
              mobile: value,
              from: today.startOf('day').toISO(),
              to: today.endOf('day').toISO(),
            })
            value = (
              <Button
                type="secondary"
                label={buttonLabel}
                size="s"
                onClick={() => navigate(`/history/?${params}`)} />
            )
            return { label: t(label), value, type }
          }
          return { label: t(label), value }
        })
        return (
          <InfoDisplay label={t(val.label)} data={infoArr} className={val.className} />
        )
      })}
    </div>
  )
})

export default MobileProfile
